import PropTypes from 'prop-types';
import React from 'react';
import { groupActions } from '../../../Includes/GroupActionTypes';
import { GroupPropTypesShape } from '../../../Includes/GroupPropsShape';
import './GroupTypeDisplay.scss';

export default class GroupTypeDisplay extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * Group information
         */
        group: PropTypes.shape(GroupPropTypesShape),
        /**
         * Function to check user's permissions for the group
         */
        hasPermission: PropTypes.func.isRequired,
    };

    static defaultProps = {
        group: {},
        hasPermission: () => {},
    };

    renderButton = () => {
        const { group, hasPermission } = this.props;
        const { privacySetting } = group;
        const isAdmin = hasPermission(groupActions.EDIT_GROUP);

        if (isAdmin && !privacySetting) {
            return (
                <a href={`/groups/edit/${group.hash}`} className="privacy-btn">
                    privacy settings
                </a>
            );
        }

        if (!isAdmin && !privacySetting) {
            return null;
        }

        return `${privacySetting} group`;
    };

    render() {
        return (
            <div className={`component-Groups-Elements-GroupTypeDisplay`}>
                {this.renderButton()}
            </div>
        );
    }
}
